import { sharedConfig } from '@/pageConfig/shared';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-US'].seo,
    title: 'Lemonade FR: Legal',
    metaTitle: 'Lemonade FR: Legal',
    description:
      'Find all essential legal documents, consumer notices, and compliance information for Lemonade in France. Stay informed about your insurance rights.',
  },
};
